import {getStylesForBackground} from './layoutFrameUtils';
import {createSelector} from 'reselect';

export const selectLayoutFrame = (state, frameId) => {
  return state.layoutFrame.layoutFrameStyles[frameId] || {};
};

export const selectFrameStyles = createSelector(
  [selectLayoutFrame, () => window.innerWidth, () => window.innerHeight],
  (frame, width, height) => {
    return getStylesForBackground(frame, width, height);
  }
);
